import React from 'react';
function Chain({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        d="M9 7c0-.667.4-2 2-2h8c.667 0 2 .4 2 2v5.5c0 .667-.4 2-2 2h-8c-.667 0-2-.4-2-2v-1"
      />
      <path
        strokeLinecap="round"
        d="M16 16.5c0 .667-.4 2-2 2H6c-.667 0-2-.4-2-2V11c0-.667.4-2 2-2h8c.667 0 2 .4 2 2v1"
      />
    </svg>
  );
}

export default Chain;
